import { formatMaskPhone } from '@format';
import React from 'react';
import InputMask from 'react-text-mask';

const FormatPhone = ({ id, name, onChange, value, className, disabled }) => {
  return (
    <InputMask
      disabled={disabled}
      id={id}
      className={className}
      onChange={(event) => {
        let valorDigito;
        if (event.target.value) {
          valorDigito = event.target.value.match(/\d/g);
          if (valorDigito) {
            valorDigito = valorDigito.join('');
          }
        }
        onChange({ target: { id, name, value: valorDigito } });
      }}
      value={value}
      mask={formatMaskPhone}
      showMask={false}
      guide={false}
    />
  );
};

export default FormatPhone;
